// src/hooks/usePageTracking.js
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from 'posthog-js';

const TRACKED_PATHS = ['/dashboard/generate/single', '/dashboard/generate/bulk', '/dashboard/generate/image', '/dashboard/generate/copy-only']; // Add your 4 page paths here

export const usePageTracking = () => {
  const location = useLocation();
  const startTimeRef = useRef(Date.now());
  const previousPathRef = useRef(location.pathname);

  useEffect(() => {
    const handlePageLeave = () => {
      const timeSpent = (Date.now() - startTimeRef.current) / 1000; // seconds
      const previousPath = previousPathRef.current;

      if (TRACKED_PATHS.includes(previousPath)) {
        posthog.capture('page_time_spent', {
          page: previousPath,
          time_spent_seconds: timeSpent,
        });
        
      }
    };

    handlePageLeave(); // when path changes

    // Start tracking the new page
    startTimeRef.current = Date.now();
    previousPathRef.current = location.pathname;

    return () => {
      handlePageLeave(); // on component unmount
    };
  }, [location.pathname]);
};
